(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eyva-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBuy(root) {
    if (!root || root.__eyvaInit) return;
    root.__eyvaInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-eyva-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-eyva-thumb]'));
    var startEl = root.querySelector('[data-eyva-active-start]');
    var idx = startEl && slides.length ? slides.indexOf(startEl) : 0;
    if (idx < 0) idx = 0;

    function pauseMedia(scope) {
      if (!scope) return;
      scope.querySelectorAll('video').forEach(function (v) {
        try { v.pause(); } catch (e) {}
      });
      scope.querySelectorAll('iframe').forEach(function (frame) {
        var src = frame.getAttribute('src');
        if (src) frame.setAttribute('src', src);
      });
    }

    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === idx;
        if (!on && slide.classList.contains('is-active')) pauseMedia(slide);
        slide.classList.toggle('is-active', on);
      });
      thumbs.forEach(function (t, n) {
        var on = n === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    if (slides.length) show(idx);
    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-index'), 10);
        show(isNaN(i) ? n : i);
      });
    });
    var prev = root.querySelector('[data-eyva-prev]');
    var next = root.querySelector('[data-eyva-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    var val = root.querySelector('[data-eyva-qty-val]');
    var qtyInput = root.querySelector('[data-eyva-qty-input]');
    var q = 1;
    root.querySelectorAll('[data-eyva-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        q = Math.max(1, q + parseInt(b.getAttribute('data-eyva-qty'), 10));
        if (val) val.textContent = q;
        if (qtyInput) qtyInput.value = q;
        var dec = root.querySelector('[data-eyva-qty="-1"]');
        if (dec) dec.disabled = q <= 1;
      });
    });

    var emi = root.querySelector('[data-eyva-emi]');
    if (emi) {
      var toggle = emi.querySelector('[data-eyva-emi-toggle]');
      var body = emi.querySelector('.eyva-buy__emi-body');
      if (toggle && body) toggle.addEventListener('click', function () {
        var open = body.hasAttribute('hidden');
        if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var form = root.querySelector('.eyva-buy__form');
    var buyNow = root.querySelector('[data-eyva-buy-now]');
    function goCheckout() {
      if (buyNow) { buyNow.click(); return; }
      if (form) {
        var formData = new FormData(form);
        fetch(window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) { if (!res.ok) throw new Error('Add to cart failed'); return res.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { form.submit(); });
        return;
      }
      var fallback = root.querySelector('.eyva-buy__cta a.eyva-btn');
      if (fallback && fallback.href) window.location.href = fallback.href;
    }
    if (buyNow && form) {
      buyNow.addEventListener('click', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch(window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) { if (!res.ok) throw new Error('Add to cart failed'); return res.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { console.error(err); form.submit(); });
      });
    }

    var sticky = root.querySelector('[data-eyva-sticky]');
    var stickyBuy = root.querySelector('[data-eyva-sticky-buy]');
    if (stickyBuy) stickyBuy.addEventListener('click', goCheckout);
    if (sticky) {
      var updateSticky = function () {
        var fold = Math.min(window.innerHeight * 0.75, root.offsetHeight * 0.55);
        var show = window.scrollY > fold;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('eyva-buy-sticky-on', show);
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-eyva-buy]').forEach(initBuy); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyva-custom-studio"] && !Shopify.designMode) return;
  try {
    
/* EYVA custom studio — pinned scroll crossfade. Scroll position is the only
   input: no wheel/touch capture, no forced scrollTo. */
(function () {
  "use strict";

  var REDUCED = "(prefers-reduced-motion: reduce)";

  /* position:sticky dies the moment an ancestor is a scroll container or
     paints in isolation, and Horizon's wrappers plus base.css's
     body{overflow-x:hidden} do exactly that. The stylesheet handles this with
     :has(); this walk covers browsers without it and any inline styles the
     theme sets at runtime. */
  function unlockStickyAncestors(el) {
    var node = el.parentElement;
    while (node && node !== document.documentElement) {
      var cs = window.getComputedStyle(node);
      if (cs.overflow !== "visible" || (cs.contain && cs.contain !== "none")) {
        node.style.overflow = "visible";
        node.style.overflowX = "clip";
        node.style.contain = "none";
      }
      node = node.parentElement;
    }
  }

  function revealTag(root) {
    var tag = root.querySelector("[data-eyva-studio-reveal]");
    if (!tag) return;
    if (!("IntersectionObserver" in window) || window.matchMedia(REDUCED).matches) {
      tag.classList.add("is-in");
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        /* anything already scrolled past reveals immediately — otherwise a
           reload part-way down the page leaves it blank forever */
        if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    io.observe(tag);
  }

  function init(root) {
    if (root.dataset.eyvaStudioReady === "1") return;
    root.dataset.eyvaStudioReady = "1";

    revealTag(root);

    var frames = [].slice.call(root.querySelectorAll("[data-eyva-studio-frame]"));
    var lines = [].slice.call(root.querySelectorAll("[data-eyva-studio-line]"));
    var ticks = [].slice.call(root.querySelectorAll(".eyva-studio__tick"));
    var count = frames.length;

    if (root.dataset.eyvaStudioAnimate === "false" || window.matchMedia(REDUCED).matches || count < 2) {
      root.classList.add("eyva-studio--flat");
      return;
    }

    unlockStickyAncestors(root);

    var ticking = false, cur = -1;

    function tick() {
      ticking = false;
      if (!root.isConnected) { stop(); return; }

      var travel = root.offsetHeight - window.innerHeight;
      if (travel <= 0) return;

      var p = Math.min(Math.max(-root.getBoundingClientRect().top / travel, 0), 1);
      var x = p * (count - 1);

      for (var i = 0; i < count; i++) {
        /* smoothstepped tent around each frame's own beat, so exactly one
           crossfade is ever in flight */
        var d = 1 - Math.min(Math.abs(x - i), 1);
        frames[i].style.opacity = d * d * (3 - 2 * d);
        frames[i].style.transform =
          "scale(" + (1.06 - 0.05 * d).toFixed(4) + ") translateY(" + ((i - x) * 12).toFixed(1) + "px)";
      }

      var now = Math.round(x);
      if (now !== cur) {
        cur = now;
        lines.forEach(function (l, i) { l.classList.toggle("is-on", i === now); });
        ticks.forEach(function (t, i) { t.classList.toggle("is-on", i === now); });
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(tick);
    }

    function stop() {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      window.removeEventListener("load", onScroll);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    /* svh-based heights and web fonts settle after load — re-measure once */
    window.addEventListener("load", onScroll);
    tick();
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    [].slice.call(context.querySelectorAll("[data-eyva-studio]")).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  /* this file is not re-executed when the editor re-renders a section, but a
     document-level listener survives, so re-init the replaced markup */
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyva-product-details"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(root) {
    if (!root || root.__eyvaTabs) return; root.__eyvaTabs = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-eyva-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-eyva-panel]'));
    var accs = Array.prototype.slice.call(root.querySelectorAll('[data-eyva-acc]'));
    function select(i) {
      tabs.forEach(function (t, n) { var on = n === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      accs.forEach(function (a, n) {
        var on = n === i;
        a.classList.toggle('is-open', on);
        a.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (a.parentElement && a.parentElement.classList.contains('eyva-det-acc-item')) {
          a.parentElement.classList.toggle('is-open', on);
        }
      });
      panels.forEach(function (p, n) { var on = n === i; p.classList.toggle('is-hidden', !on); if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); });
    }
    function collapseAll() {
      accs.forEach(function (a) {
        a.classList.remove('is-open');
        a.setAttribute('aria-expanded', 'false');
        if (a.parentElement && a.parentElement.classList.contains('eyva-det-acc-item')) {
          a.parentElement.classList.remove('is-open');
        }
      });
      panels.forEach(function (p) { p.classList.add('is-hidden'); p.setAttribute('hidden', ''); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault();
        var n = (i + d + tabs.length) % tabs.length; select(n); tabs[n].focus();
      });
    });
    accs.forEach(function (a, i) {
      a.addEventListener('click', function () {
        if (a.classList.contains('is-open')) collapseAll(); else select(i);
      });
    });
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width:821px)');
      var onChange = function (e) {
        if (!e.matches) return;
        // Back on desktop: make sure the active tab's panel is visible again
        var open = panels.some(function (p) { return !p.hasAttribute('hidden'); });
        if (!open) { var i = tabs.findIndex(function (t) { return t.classList.contains('is-active'); }); select(i < 0 ? 0 : i); }
      };
      if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
    }
  }
  function initReviews(root) {
    if (!root || root.__eyvaReviews) return; root.__eyvaReviews = true;
    root.querySelectorAll('[data-eyva-reviews]').forEach(function (wrap) {
      var initial = parseInt(wrap.getAttribute('data-eyva-reviews-initial'), 10) || 4;
      var step = parseInt(wrap.getAttribute('data-eyva-reviews-step'), 10) || 4;
      var moreBtn = wrap.querySelector('[data-eyva-reviews-more]');
      var lessBtn = wrap.querySelector('[data-eyva-reviews-less]');
      if (!moreBtn && !lessBtn) return;
      function cards() { return Array.prototype.slice.call(wrap.querySelectorAll('[data-eyva-review]')); }
      function sync() {
        var list = cards();
        var hidden = list.filter(function (c) { return c.classList.contains('is-collapsed'); }).length;
        var visible = list.length - hidden;
        if (moreBtn) {
          if (hidden > 0) moreBtn.removeAttribute('hidden'); else moreBtn.setAttribute('hidden', '');
          moreBtn.setAttribute('aria-expanded', visible > initial ? 'true' : 'false');
        }
        if (lessBtn) {
          if (visible > initial) lessBtn.removeAttribute('hidden'); else lessBtn.setAttribute('hidden', '');
        }
      }
      if (moreBtn) moreBtn.addEventListener('click', function () {
        cards().filter(function (c) { return c.classList.contains('is-collapsed'); })
          .slice(0, step)
          .forEach(function (card) { card.classList.remove('is-collapsed'); });
        sync();
      });
      if (lessBtn) lessBtn.addEventListener('click', function () {
        cards().forEach(function (card, i) {
          if (i >= initial) card.classList.add('is-collapsed');
        });
        sync();
      });
      sync();
    });
  }
  function initAll(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-eyva-tabs]').forEach(initTabs);
    s.querySelectorAll('[data-eyva-tabs]').forEach(initReviews);
  }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
